import { combineReducers } from 'redux'

import usuario from './usuario'
import enquiries from "./enquiries";
import rooms from "./rooms";
import conta from "./conta";
//import calendario from "./calendario";
import activities from "./activities";

const rootReducer = combineReducers({
	usuario: usuario,
	enquiries: enquiries,
	rooms:rooms,
	conta:conta,
	activities:activities
});

export interface RootState {
	usuario: any;
	enquiries: any;
	rooms: any;
	conta: any;
	activities: any;
  }

export default rootReducer

